import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6a82c16e&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6a82c16e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a82c16e",
  null
  
)

/* custom blocks */
import block0 from "@/lang/products/broadband?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230601152131%2Fpages%2Fcompare-tv-broadband-phone%2Findex.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SiteAddressCapturePoint: require('/home/ubuntu/nuxt/bonkers/releases/20230601152131/components/site/address-capture-point.vue').default,ProductsHumanising: require('/home/ubuntu/nuxt/bonkers/releases/20230601152131/components/products/humanising.vue').default,ProductsMoreInfo: require('/home/ubuntu/nuxt/bonkers/releases/20230601152131/components/products/more-info.vue').default,WidgetsAlertMessage: require('/home/ubuntu/nuxt/bonkers/releases/20230601152131/components/widgets/alert-message.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20230601152131/components/site/feefo.vue').default})
